// extracted by mini-css-extract-plugin
export var columnList = "_bf-0";